import type { ReactNode } from "react";

import { Box, Typography } from "@braintrust/braintrust-ui-components";
import { useMediaQuery } from "@braintrust/braintrust-ui-components";
import { Emoji } from "@js/components/emoji";

import styles from "./styles.module.scss";

export type SystemMessageCardContentProps = {
  emoji: string;
  emojiBackground: string;
  title: ReactNode;
  subtitle?: ReactNode;
  additionalMessage?: ReactNode;
};

export const SystemMessageCardContent = ({
  emoji,
  emojiBackground,
  title,
  subtitle,
  additionalMessage,
}: SystemMessageCardContentProps) => {
  const isMobile = useMediaQuery("sm");

  return (
    <div className={styles.systemMessageContent}>
      <Box className={styles.emoji} sx={{ backgroundColor: emojiBackground }}>
        <Emoji emoji={emoji} size="24px" />
      </Box>
      <Typography size={isMobile ? "medium" : "large"} component="p">
        {title}
      </Typography>
      <Typography size={isMobile ? "small" : "medium"} component="p">
        {subtitle}
      </Typography>
      {additionalMessage && (
        <div className={styles.additionalMessage}>{additionalMessage}</div>
      )}
    </div>
  );
};
